import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ResalesService = {
    list: async () => axios.get(API_URL + "/templates/list").then(({data}) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + "/templates/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (model) => axios.post(API_URL + "/templates", model).then(({data}) => data).catch((err) => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/templates/" + id, model).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/templates/" + id).then(({data}) => data).catch((err) => { throw err }),
    options: async () => axios.get(API_URL + "/templates/get/options").then(({data}) => data).catch((err) => { throw  err})
};

export default ResalesService;